import React, { Component } from 'react';
import InputFloating from './../../../commons/InputFloating.js';
import SellerReturnsApiHandler from './../SellerReturnsApiHandler.js';
import Loader from './../../../commons/Loader.js';
import ErrorBox from './../../../commons/ErrorBox';

export default class ViewDeliveryChallan extends Component {
	constructor(props){
		super(props);
		this.state = {
			generatedChallans: null,
			selectedDate: ''
		}
	}

	closeError = () => {
		this.setState({error: null})
	}

	dateChanged = (e) => {
		this.setState({selectedDate: e.target.value});
	}

	fetchGeneratedChallan = () => {
		this.setState({loading: true, generatedChallans: null});
		let timeStamp = new Date(this.state.selectedDate).getTime() - 330 * 60000;
		SellerReturnsApiHandler.getGeneratedNotes(timeStamp)
			.then(resp => {
				this.setState({generatedChallans: resp});
			}).catch(error => {
				this.setState({error: error.error.error});
			}).finally(() => {
				this.setState({loading: false});
			})
	}


	showGeneratedChallans = () => {
		const {generatedChallans} = this.state;

		return generatedChallans.map((c, index) => {
			return (
				<div className="generated-challan-outer" key={index}>
					<div className="row">
						<div className="col-md-6" style={{paddingRight: '60px'}}>
							<div className="dc-num">DC No : {c.returnChalanId}</div>
							<div className="dc-link top-ten">DC LINK : <a href={c.returnChalanUrl} target="_">{c.returnChalanUrl}</a></div>
						</div>
						<div className="col-md-6" style={{paddingRight: '60px'}}>
							<div className="dc-num">CN No : {c.creditNoteId}</div>
							<div className="dc-link top-ten">CN LINK : <a href={c.creditNoteUrl} target="_">{c.creditNoteUrl}</a></div>
						</div>
					</div>
				</div>
			)
		})
	}

	render() {
		const {selectedDate, generatedChallans, loading, error} = this.state;
		return(
			<div className="pickjobs-wrapper">
				<div className="seller-return-outer">
					<div style={{fontSize: '18px', fontWeight: 'bold'}}>View Delivery Challans</div>
					<div className="row top-thirty" >
						<div className="col-xs-8 col-md-3">
							<InputFloating type="date" label="Date of delivery" value={selectedDate} onChange={this.dateChanged}/>
						</div>
						<div className="col-xs-4 col-md-1 no-padding">
							<button className="btn btn-jt-green" style={{width: '100%', padding: '11.5px'}} disabled={selectedDate && !loading ?false:true} onClick={this.fetchGeneratedChallan}>View</button>
						</div>
						<div className="col-md-7"></div>
					</div>
					{(generatedChallans)?
					<div className="top-thirty">
						<div>{this.showGeneratedChallans()}</div>
					</div>:null
					}
				</div>
				{(loading)?
					<Loader />:null
				}
				{(error)?
		 			<ErrorBox errorText={this.state.error} closeError={this.closeError}/>:null
    			}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/SellerReturns/Components/ViewDeliveryChallan.js